import React from 'react';
import BasicMeta from '../BasicMeta';

const descriptions = {
  se: {
    description: 'Läs vår bloggar från våra duktiga profiler. Under denna sektionen hittar du Bojan Djordjic, Lindquists NHL-blogg, Blomqvists formel 1, Jihdes hockeykrönika.',
    title: 'Bloggar',
  },
  no: {
    description: 'Petter Veland, Roar Stokke og Atle Gulbrandsen er blant de som har sin egen blogg på Viasport. Her kan du lese hva ekspertene mener.',
    title: 'Blogger',
  },
  dk: {
    description: 'Jan Mølby, Henrik Levysohn, Peter Grønborg og Daniel Ortved er blandt vores bloggere på TV3sport.dk. Her kan du læse hvad eksperterne mener om Premiere League, Champions League, ALKA superligaen og NFL.',
    title: 'Blog',
  },
  fi: {
    description: '',
    title: '',
  },
};

export default class BlogMeta extends React.PureComponent {
  render() {
    return (
       <BasicMeta descriptions={descriptions} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/MediaPages/BlogMeta.jsx